import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const useMaxPriorityStore = create<{
  maxPriority: number;
  setMaxPriority: (priority: number) => void;
}>()(
  devtools(
    (set) => ({
       maxPriority: 0,
      setMaxPriority: (maxPriority) => set(() => ({ maxPriority }),
        undefined,
        'GlobalStore/setMaxPriority'
      ),
    }),
    { name: 'MaxPriorityStore' }
  )
);

export default useMaxPriorityStore;
